_options$now